export default __webpack_public_path__ + "static/data-vis-categorical-chart-light-0edda7d4191bac35763aafc4c4877163d9f922bd4438aaba1afb232c24184d6e.png";